import { render, staticRenderFns } from "./my-reward.vue?vue&type=template&id=8b6c4e0e&scoped=true"
import script from "./my-reward.vue?vue&type=script&lang=js"
export * from "./my-reward.vue?vue&type=script&lang=js"
import style0 from "./my-reward.vue?vue&type=style&index=0&id=8b6c4e0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6c4e0e",
  null
  
)

export default component.exports